export const BOUNDARY_COUNT = 4;
export const SIBLING_COUNT = 5;

/**
 * Determines if a page should be displayed in the pagination component.
 *
 * @param itemPage The page number of the item.
 * @param currentPage The current page number.
 * @param totalPages The total number of pages.
 * @returns boolean Returns true if the page should be displayed, false otherwise.
 */
export const shouldDisplayPage = (itemPage: number, currentPage: number, totalPages: number) => {
    return (
        // Display if the page number is a ten
        itemPage % 10 === 0 ||
        // Display if the page number is the current page
        itemPage === currentPage ||
        // Display if the page number is one before or after the current page
        (itemPage >= currentPage - SIBLING_COUNT && itemPage <= currentPage + SIBLING_COUNT) ||
        // Always display the first and last page
        itemPage === 1 ||
        itemPage === totalPages ||
        // If the current page is the first page, display the next BOUNDARY_COUNT pages
        (currentPage === 1 && itemPage <= currentPage + BOUNDARY_COUNT) ||
        // If the current page is the last page, display the previous BOUNDARY_COUNT pages
        (currentPage === totalPages && itemPage >= currentPage - BOUNDARY_COUNT)
    );
};
